export const musicTracks = [
    {
        title: "Music box white Christmas",
        artist: "Quick Sound",
        color: "#00873E",
        image: "https://images.pexels.com/photos/250177/pexels-photo-250177.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250",
        audioSrc: "https://quicksounds.com/uploads/tracks/599522883_346981382_2088599616.mp3"
    },
    {
        title: "Merry Christmas",
        artist: "Quick Sound",
        color: "#EBBB5A",
        image: "https://images.pexels.com/photos/1656564/pexels-photo-1656564.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250",
        audioSrc: "https://quicksounds.com/uploads/tracks/990442331_1771754036_30936103.mp3"
    },
    {
        title: "Night Owl",
        artist: "Broke For Free",
        color: "#00aeb0",
        image: "https://images.pexels.com/photos/2264753/pexels-photo-2264753.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250",
        audioSrc: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/WFMU/Broke_For_Free/Directionless_EP/Broke_For_Free_-_01_-_Night_Owl.mp3"
    },
    {
        title: "Enthusiast",
        artist: "Tours",
        color: "#ffb77a",
        image: "https://images.pexels.com/photos/3100835/pexels-photo-3100835.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250",
        audioSrc: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/no_curator/Tours/Enthusiast/Tours_-_01_-_Enthusiast.mp3"
    },
    {
        title: "Shipping Lanes",
        artist: "Chad Crouch",
        color: "#5f9fff",
        image: "https://images.pexels.com/photos/1717969/pexels-photo-1717969.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250",
        audioSrc: "https://files.freemusicarchive.org/storage-freemusicarchive-org/music/ccCommunity/Chad_Crouch/Arps/Chad_Crouch_-_Shipping_Lanes.mp3",
    },
];
